export default (href, target) => {
    window.open(href, target);
};
